import React from 'react';

import { styled } from '@mui/material/styles';
import { Badge, Box, Stack, Typography } from '@mui/material';

const IconWrapper = styled(Stack)(({ theme }) => ({
  position: 'relative',
  width: '24px',
  height: '24px',
  cursor: 'pointer',
  borderRadius: '100%',

  '&:hover': {
    '& .icon-hover': {
      backgroundColor: '#F0F0F0',
    },
  },

  '& .MuiSvgIcon-root': {
    width: '20px',
    height: '20px',
    color: theme.palette.neutral500.main,
  },
}));

const BgHover = styled(Box)(() => ({
  width: '32px',
  height: '32px',
  borderRadius: '100%',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  transition: 'background-color 0.3s',
}));

const IconNav = ({ children, onClick, value }) => {
  return (
    <IconWrapper alignItems="center" justifyContent="center" onClick={onClick}>
      <Badge
        color="error500"
        invisible={!value}
        badgeContent={
          <Typography
            variant="metadatabold10"
            lineHeight="11px !important"
            color="error300.main"
          >
            {value}
          </Typography>
        }
        sx={{ zIndex: 1 }}
      >
        {children}
      </Badge>

      <BgHover className="icon-hover" />
    </IconWrapper>
  );
};

export default IconNav;
